import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i1 from 'primeng/dynamicdialog';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import * as i3 from 'primeng/galleria';
import { GalleriaModule } from 'primeng/galleria';
import * as i4 from 'primeng/api';
import * as i5 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';

class ImageViewerComponent {
    constructor(dialogService) {
        this.dialogService = dialogService;
        this.images = [];
        this.imageIndex = 0;
        this.numVisible = "5";
        this.displayLargeImage = false;
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 5
            },
            {
                breakpoint: '768px',
                numVisible: 3
            },
            {
                breakpoint: '560px',
                numVisible: 1
            }
        ];
        console.log(this.images);
    }
    ngOnInit() {
        // this didn't work to allow max usage of window for sizing
        // const max_width = Math.round(window.innerWidth * 0.9);
        // this.styleString = "{'max-width': '" + max_width + "px'}";
    }
    // showLargeImage sets the dialog containing the galleria to display to true.  
    // Additionally, the imageIndex, the index of the main galleria viewing area, is set.  However,
    // if the image index is the same as the last time a user wanted to view a larger image, the
    // image shown is the same as the last time but this might be a different stations.  Therefore,
    // the image index is temporarily increased by one, then changed back again in a timeout function.
    showLargeImage(index) {
        // if the image index is the same, we haev to trick Galleria into thinking it has changed.
        if (this.imageIndex === index) {
            console.log('Adjusting imageIndex');
            this.imageIndex++;
            const self = this;
            setTimeout(function () {
                console.log('In setTimeout function');
                self.imageIndex = index;
                self.displayLargeImage = true;
            }, 100);
        }
        else {
            // the image index was different so the setTimeout function doesn't need to be utilized
            this.imageIndex = index;
            this.displayLargeImage = true;
        }
        console.log(this.images);
    }
}
ImageViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageViewerComponent, deps: [{ token: i1.DialogService }], target: i0.ɵɵFactoryTarget.Component });
ImageViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: ImageViewerComponent, selector: "lib-image-viewer", inputs: { images: "images", header: "header" }, providers: [DialogService], ngImport: i0, template: "<div>\n    <ul>\n\t\t<li *ngFor=\"let image of images; index as i\">\n            <img src={{image.source}} class=\"thumbnail\" title={{image.title}} (click)=\"showLargeImage(i)\"/>\n        </li>\n    </ul>\n</div>\n\n<p-dialog header={{header}} [(visible)]=\"displayLargeImage\">\n    <p-galleria [value]=\"images\" [(activeIndex)]=\"imageIndex\" [responsiveOptions]=\"responsiveOptions\" [numVisible]=\"numVisible\" [showItemNavigators]=true [containerStyle]=\"{'max-width': '1000px'}\">\n        <ng-template pTemplate=\"item\" let-item>\n            <img *ngIf=\"item!=null\" [src]=\"item.source\" style=\"width: 100%; display: block;\" [alt]=\"item.title\" />\n        </ng-template>\n        <ng-template pTemplate=\"thumbnail\" let-item>\n            <div *ngIf=\"item!=null\" class=\"p-grid p-nogutter p-justify-center\">\n                <img [src]=\"item.thumbnail\" />\n            </div>\n        </ng-template>\n    </p-galleria>\n</p-dialog>\n", styles: ["ul{list-style-type:none;margin:0;padding:0}li{float:left}.thumbnail{height:200px;border:1px solid #ddd;padding:4px}\n"], dependencies: [{ kind: "directive", type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.Galleria, selector: "p-galleria", inputs: ["activeIndex", "fullScreen", "id", "value", "numVisible", "responsiveOptions", "showItemNavigators", "showThumbnailNavigators", "showItemNavigatorsOnHover", "changeItemOnIndicatorHover", "circular", "autoPlay", "transitionInterval", "showThumbnails", "thumbnailsPosition", "verticalThumbnailViewPortHeight", "showIndicators", "showIndicatorsOnItem", "indicatorsPosition", "baseZIndex", "maskClass", "containerClass", "containerStyle", "showTransitionOptions", "hideTransitionOptions", "visible"], outputs: ["activeIndexChange", "visibleChange"] }, { kind: "directive", type: i4.PrimeTemplate, selector: "[pTemplate]", inputs: ["type", "pTemplate"] }, { kind: "component", type: i5.Dialog, selector: "p-dialog", inputs: ["header", "draggable", "resizable", "positionLeft", "positionTop", "contentStyle", "contentStyleClass", "modal", "closeOnEscape", "dismissableMask", "rtl", "closable", "responsive", "appendTo", "breakpoints", "styleClass", "maskStyleClass", "showHeader", "breakpoint", "blockScroll", "autoZIndex", "baseZIndex", "minX", "minY", "focusOnShow", "maximizable", "keepInViewport", "focusTrap", "transitionOptions", "closeIcon", "closeAriaLabel", "closeTabindex", "minimizeIcon", "maximizeIcon", "visible", "style", "position"], outputs: ["onShow", "onHide", "visibleChange", "onResizeInit", "onResizeEnd", "onDragEnd", "onMaximize"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-image-viewer', providers: [DialogService], template: "<div>\n    <ul>\n\t\t<li *ngFor=\"let image of images; index as i\">\n            <img src={{image.source}} class=\"thumbnail\" title={{image.title}} (click)=\"showLargeImage(i)\"/>\n        </li>\n    </ul>\n</div>\n\n<p-dialog header={{header}} [(visible)]=\"displayLargeImage\">\n    <p-galleria [value]=\"images\" [(activeIndex)]=\"imageIndex\" [responsiveOptions]=\"responsiveOptions\" [numVisible]=\"numVisible\" [showItemNavigators]=true [containerStyle]=\"{'max-width': '1000px'}\">\n        <ng-template pTemplate=\"item\" let-item>\n            <img *ngIf=\"item!=null\" [src]=\"item.source\" style=\"width: 100%; display: block;\" [alt]=\"item.title\" />\n        </ng-template>\n        <ng-template pTemplate=\"thumbnail\" let-item>\n            <div *ngIf=\"item!=null\" class=\"p-grid p-nogutter p-justify-center\">\n                <img [src]=\"item.thumbnail\" />\n            </div>\n        </ng-template>\n    </p-galleria>\n</p-dialog>\n", styles: ["ul{list-style-type:none;margin:0;padding:0}li{float:left}.thumbnail{height:200px;border:1px solid #ddd;padding:4px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.DialogService }]; }, propDecorators: { images: [{
                type: Input
            }], header: [{
                type: Input
            }] } });

class ImageViewerModule {
}
ImageViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ImageViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: ImageViewerModule, declarations: [ImageViewerComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        GalleriaModule,
        DialogModule,
        DynamicDialogModule], exports: [ImageViewerComponent] });
ImageViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageViewerModule, imports: [BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        GalleriaModule,
        DialogModule,
        DynamicDialogModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: ImageViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ImageViewerComponent
                    ],
                    imports: [
                        BrowserModule,
                        BrowserAnimationsModule,
                        CommonModule,
                        GalleriaModule,
                        DialogModule,
                        DynamicDialogModule
                    ],
                    exports: [
                        ImageViewerComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ImageViewerComponent, ImageViewerModule };
